<section class="evrn-to-video section section__bg-gradient-parent">
  <div class="evrn-to-video__gradient section__bg-gradient" aria-hidden="true"></div>

  <div class="evrn-to-video__inner container">
    <div class="evrn-to-video__expandable-cards">
      <h2 class="evrn-to-video__title title">EVRN to Video</h2>

      <app-hover-expandable-cards [cards]="expandableCards" />
    </div>

    <div class="evrn-to-video__content">
      <h2 class="evrn-to-video__content-title title">
        EVRN does what I need it to do. I can put it to work today.
      </h2>

      <p class="evrn-to-video__content-subtitle subheading">
        Kevin Haug / VFX Supervisor Fight Club
      </p>

      <app-button [href]="`${environment.appUrl}/auth/register`">Start directing</app-button>
    </div>
  </div>
</section>
